import $ from "jquery";
import jQuery from "jquery";

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

// require swiper
require('swiper/dist/js/swiper.jquery.min.js');
require('swiper/dist/css/swiper.min.css');

import i18n from "./lang";
import {Builder} from "./builder/builder";
import {Filters} from "./builder/filters/filters";

window.lang = $('html').attr('lang');

$(function () {
    $.ajaxSetup({
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
    });

    $('input[data-min],input[data-max]').on('input', function () {
        let $input = $(this);
        let d = $input.data();
        let v = $input.val();

        if (d.min !== undefined) {
            v = Math.max(d.min, v);
        }

        if (d.max !== undefined) {
            v = Math.min(d.max, v);
        }

        $input.val(v);
    });

    // header swiper
    var headerSwiper = new Swiper('.page .slides .swiper-container', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: 5000,
        autoplayDisableOnInteraction: true,
        effect: 'fade',
        speed: 1000
    });

    $('builder').each(function () {
        let $this = $(this);
        let data = $.extend({}, JSON.parse($this.attr('value') || '{}'));
        data['image'] = $this.attr('image');
        new Builder({
            el: this,
            i18n: i18n,
            data: data,
        });
    });


    // $(window).unload(function(){
    //     myfun();
    //     alert('Bye.');
    // });

    let $terms_submit = $('#terms-submit');

    $('input[type=checkbox]#terms').on('change', function () {
        let $box = $(this);

        $terms_submit.toggleClass('disabled', !$box.is(':checked'));
        $terms_submit.prop('disabled', !$box.is(':checked'));
    }).trigger('change');

    $terms_submit.on('click', function () {
        if (!$terms_submit.is(':disabled')) {
            $terms_submit.closest('form').submit();
        }
    });

    $('.tabs .tab-buttons > div').on('click', function () {
        var tab = $(this).data('tab');
        var $tab_buttons = $(this).parent();
        var $tab_content = $tab_buttons.next('.tab-content');

        $tab_buttons.find('> .active').removeClass('active');
        $tab_content.find('> .active').removeClass('active');

        $(this).addClass('active');
        $tab_content.find('> [data-tab="' + tab + '"]').addClass('active');
    });

    $('.disabled').on('click', function (e) {
        e.preventDefault();
    });

    $('filters').each(function () {
        let $this = $(this);
        let data = $.extend({}, JSON.parse($this.attr('value') || '{}'));

        data.name = $this.attr('name');

        new Filters({
            el: this,
            i18n: i18n,
            data: data,
        });
    });

    $('#redirect-builder').on('change', function () {
        let $this = $(this);
        location.href = $this.val();
    });

    $('.close-popup').on('click', function () {
        $(this).closest('.overlay').remove();

        $('body').removeClass('noscroll');
    });

    let $selects = $('.custom-select');

    $selects.each(function () {
        var $sel = $(this);
        $sel.find('.handle').on('click', function () {
            $sel.toggleClass('active');
        });
    });

    $('body').on('click', function (e) {
        $selects.not($(e.target).closest('.custom-select')).removeClass('active');
    });
});
